'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateTimeHelper = function () {
    function DateTimeHelper() {
        _classCallCheck(this, DateTimeHelper);
    }

    _createClass(DateTimeHelper, [{
        key: 'convertICUHours',
        value: function convertICUHours(inputInMinutes) {
            // Convert minutes to seconds
            var seconds = inputInMinutes ? inputInMinutes * 60 : 0;

            // Calculate (and subtract) whole hours
            var hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;

            // Calculate (and subtract) whole minutes
            var minutes = Math.floor(seconds / 60) % 60;

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
        }
    }]);

    return DateTimeHelper;
}();

exports.default = DateTimeHelper;


// WEBPACK FOOTER //
// ./client/app/common/utils/DateTimeHelper.js